var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4783 13.0435C23.4783 11.4918 22.3461 10.2125 20.8643 9.96522C19.5892 6.29217 16.1071 3.65217 12 3.65217C7.89286 3.65217 4.41077 6.29217 3.13564 9.96522C1.6539 10.2125 0.521729 11.4918 0.521729 13.0435C0.521729 14.5951 1.6539 15.8744 3.13564 16.1217C4.41077 19.7948 7.89286 22.4348 12 22.4348C16.1071 22.4348 19.5892 19.7948 20.8643 16.1217C22.3461 15.8744 23.4783 14.5951 23.4783 13.0435Z",
    fill: "#f69516",
    stroke: "#6D4B40",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.28259,
    cy: 14.5435,
    r: 1.5,
    fill: "#6D4B40"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5869,
    cy: 14.5435,
    r: 1.5,
    fill: "#6D4B40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.78261C11.7391 3.04383 13.7395 0.738782 17.2174 0.521739",
    stroke: "#6D4B40",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildcare);
export default __webpack_public_path__ + "static/media/childcare.3ec2953cfed7cc3e49d7302c39fefdbc.svg";
export { ForwardRef as ReactComponent };